import { configuration } from "./configuration";

configuration();

// split the app so that we can be sure the configuration is loaded before everything else
import("./bootstrap").then(({ bootstrapApp }) => {
  bootstrapApp();
});
